var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResidentiW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_8005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1124 28.2525V26.4777C19.1124 24.6556 17.6538 23.1921 15.8694 23.1921H9.38321C7.58465 23.1921 6.14014 24.6699 6.14014 26.4777V28.2525",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.869 16.6215C15.869 18.4437 14.4103 19.9071 12.6259 19.9071C10.8415 19.9071 9.38281 18.4293 9.38281 16.6215C9.38281 14.8137 10.8415 13.3359 12.6259 13.3359C14.4103 13.3359 15.869 14.8137 15.869 16.6215Z",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.97 28.2528V26.4781C23.97 24.9859 22.9645 23.6803 21.5342 23.3073",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.291 13.4504C20.0329 13.9096 21.0668 15.6887 20.6277 17.4534C20.3303 18.6156 19.4381 19.5195 18.291 19.8208",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14.4949L13.551 2.68013C14.4747 1.77345 15.9668 1.77345 16.9048 2.68013L28.572 14.1322",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_8005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentiW);
export default __webpack_public_path__ + "static/media/residentiW.9cad96710bcac49cdcfa8dc4a511c5da.svg";
export { ForwardRef as ReactComponent };